import { makeStyles } from "@mui/styles";

const useThankyouPageStyle = makeStyles((theme) => ({
    container: {
      width: "50%",
      margin: "5rem auto",
      textAlign: "center",
      // [theme.breakpoints.down("xs")]: {
      //   width: "90%",
      // },
      "& .MuiTypography-h3": {
        fontSize: "2rem",
        color: "#303030",
      },
      "& .MuiListItemIcon-root": {
        minWidth: "30px",
      },
      "& .MuiTypography-body1": {
        color: "#2D2C2C",
        fontSize: "1.025rem",
      },
      "& .MuiList-root": {
        width: "85%",
        margin: "0 auto",
      },
    },
    heading: {
      width: "90%",
      margin: "1rem auto",
    },
    instructionContainer: {
      marginTop: "1.5rem",
      padding: "1rem",
      background: "#F4F7FF",
    },
  }));
  
export default useThankyouPageStyle;
